// src/redux/tradeHistory/reducer.js
import {
    FETCH_TRADE_HISTORY_REQUEST,
    FETCH_TRADE_HISTORY_SUCCESS,
    FETCH_TRADE_HISTORY_FAILURE
} from "../../ActionTypes/ActionTypes.js";

const initialState = {
    loading: false,
    list: [],
    pagination: {
        page: 1,
        limit: 10,
        total: 0,
        totalPages: 0,
    },
    summary: {
        totalBuyQty: 0,
        totalSellQty: 0,
        totalProfit: 0,
    },
    error: null,
    isFirstLoad: true
};

export const tradeReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_TRADE_HISTORY_REQUEST:
            return { ...state, loading: state.isFirstLoad, error: null };

        case FETCH_TRADE_HISTORY_SUCCESS:
            return {
                ...state,
                loading: false,
                list: action.payload.list,
                pagination: action.payload.pagination,
                summary: action.payload.summary,
                error: null,
                isFirstLoad: false
            };

        case FETCH_TRADE_HISTORY_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
                isFirstLoad: false

            };
            

        default:
            return state;
    }
};